export default [
  "gmaill.com",
  "gamil.com",
  "gmali.com",
  "gnail.com",
  "gmil.com",
  "gamail.com",
  "hotmai.com",
  "gmial.com",
  "hotmal.com",
  "yaho.com",
  "outlokk.com",
  "gmil.com",
  "hotmial.com",
  "yahooo.com",
  "otulook.com",
  "gamil.com",
  "hotnail.com",
  "yaoo.com",
  "outlok.com",
  "gmail.cmo",
  "hotmail.cmo",
  "yahho.com",
  "outloook.com",
  "gmaail.com",
  "hottmail.com",
  "yaho.com",
  "outllok.com",
  "gmai.com",
  "hotmil.com",
  "yhaoo.com",
  "outlookk.com",
  "gmil.com",
  "htmial.com",
  "yaahoo.com",
  "otlook.com",
  "gamail.com",
  "hotnail.com",
  "yaoho.com",
  "outlok.com",
  "gemail.com",
  "hotmiall.com",
  "yahhoo.com",
  "outloookk.com",
  "gmal.com",
  "hottmail.com",
  "yahio.com",
  "outlokkk.com",
  ".comm",
  ".con",
  ".cmo",
  ".coom",
  ".cim",
  ".vom",
  "-online.de",
  "-tonline.de",
  "acor.de",
  "aecor.de",
  "ahoo.de",
  "al.com",
  "ao.com",
  "aol.cm",
  "aol.con",
  "aol.ocm",
  "aol.om",
  "aoll.com",
  "apl.com",
  "arco.de",
  "arocr.de",
  "aror.de",
  "feenet.de",
  "freeenet.de",
  "freeent.de",
  "freeet.de",
  "freemet.de",
  "freeneet.de",
  "freent.de",
  "frenet.de",
  "gm.de",
  "gm.net",
  "gm.xde",
  "gmc.de",
  "gmx.ded",
  "gmx.dw",
  "gmxx.de",
  "gmy.de",
  "gx.de",
  "hmx.de",
  "homail.de",
  "hotmai.de",
  "hotmal.de",
  "mx.de",
  "mx.net",
  "@otmail.com",
  "r-online.de",
  "rcor.de",
  "reenet.de",
  "t--online.de",
  "t-0nline.de",
  "t-nline.de",
  "t-oline.de",
  "t-omline.de",
  "t-onine.de",
  "t-onlien.de",
  "t-onliine.de",
  "t-onlin.de",
  "t-onlinde.de",
  "t-onlinr.de",
  "t-onlione.de",
  "t-onlline.de",
  "t-onlne.de",
  "t-onlone.de",
  "t.-online.de",
  "t.online.de",
  "tonline.de",
  "wb.de",
  "we.de",
  "web.ded",
  "web.dw",
  "wed.de",
  "weeb.de",
  "wen.de",
  "wweb.de",
  "yaho.de",
  "yahooo.de",
  "yaoo.de",
  "yhoo.de",
  "yahhoo.de",
  "icoud.com",
  "icloud.cim",
  "icloud.con",
  "icloud.ocm",
  "icloud.om",
  "icloud.cm",
];
// source(from line 1 - 48): Generated using ChatGPT
// source(from line 48 - 127): https://github.com/gruns/typo
